// extracted by mini-css-extract-plugin
export var printerCard = "_bc-1";
export var printerCardConfigured = "_bc-2";
export var printerCardError = "_bc-3";
export var printerCardsContainer = "_bc-0";
export var printerIcon = "_bc-8";
export var printerIconConfigured = "_bc-5";
export var printerIconContainer = "_bc-4";
export var printerIconError = "_bc-6";
export var printerIconUnconfigured = "_bc-7";
export var workstationsTableCard = "_bc-9";